import { InverseHeader } from '@jouzen/ecom-components/layout';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';

export const NewsroomHero = () => {
  const t = useTranslations();

  return (
    <section data-cy="newsroom-hero-section">
      <InverseHeader enter>
        <LayoutGrid>
          <GridItem
            className="relative"
            colEnd={{ sm: 'full' }}
            colStart={{ sm: 'full' }}
            rowEnd={{ sm: 2 }}
            rowStart={{ sm: 1 }}
          >
            <ArtDirectionImage
              localizedAlt="man_typing_alt"
              className="object-cover"
              fill
              format="png"
              sizes="(max-width: 767px) 100vw, 25vw"
              srcSet={[
                {
                  src: 'newsroom-mobile-hero',
                  media: '(max-width: 767px)',
                },
                {
                  src: 'newroom_jade_hero',
                  media: '(min-width: 768px)',
                },
              ]}
            />
          </GridItem>
          <GridItem
            className="relative py-64 lg:py-60"
            colEnd={{ sm: 'main' }}
            colStart={{ sm: 'main' }}
            rowEnd={{ sm: 2 }}
            rowStart={{ sm: 1 }}
          >
            <Typography
              Element="h1"
              variant="h4"
              color="light"
              className="mb-4"
            >
              {t('newsroom_link')}
            </Typography>
            <Typography variant="h1" color="light">
              {t('press_title_subheading')}
            </Typography>
          </GridItem>
        </LayoutGrid>
      </InverseHeader>
    </section>
  );
};
